// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" py={6} mt={6}>
      <Container>
        <Grid container spacing={3} item xs={12} lg={8} mx="auto">
          <MKTypography variant="h3" mb={7}>
            ¿Qué es la Prueba de Penetración de Aplicaciones Móviles?
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La Prueba de Penetración de Aplicaciones Móviles, a menudo denominada prueba de penetración de aplicaciones móviles, es un enfoque sistemático y riguroso para evaluar la seguridad de las aplicaciones móviles. Implica pruebas y análisis en profundidad para identificar vulnerabilidades y debilidades que podrían ser explotadas por actores malintencionados.
          </MKTypography>
          <MKTypography variant="h3" mb={7} mt={7}>
            Aspectos Clave de la Prueba de Penetración de Aplicaciones Móviles
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="code"
                title="Diversidad de Plataformas"
                description="Las pruebas cubren una variedad de plataformas móviles, incluidas iOS y Android, asegurando una cobertura integral para diferentes ecosistemas móviles."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="settings_account_box"
                title="Metodología Personalizada"
                description="La metodología de prueba se adapta a las características y funcionalidades únicas de cada aplicación móvil, asegurando que la evaluación esté alineada con los objetivos de seguridad de la organización."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="pentagon"
                title="Evaluación Integral"
                description="La prueba de penetración de aplicaciones móviles evalúa varios aspectos de la seguridad de la aplicación, incluidos el almacenamiento de datos, la comunicación en red, los mecanismos de autenticación y el código del lado del cliente."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="description"
                title="Informes Detallados"
                description="Las organizaciones reciben informes detallados que describen las vulnerabilidades identificadas, su impacto potencial y recomendaciones para la mitigación y remediación específicas para aplicaciones móviles."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="view_in_ar"
                title="Escenarios de Ataque Realistas"
                description="Los evaluadores emplean técnicas y tácticas similares a las utilizadas por posibles atacantes, emulando escenarios de ataque del mundo real para descubrir vulnerabilidades y debilidades."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            ¿Por qué Importa la Prueba de Penetración de Aplicaciones Móviles?
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="lock"
                title="Protección de Datos del Usuario"
                description="Salvaguarda los datos sensibles del usuario, como información personal, detalles de pago y credenciales, asegurando la privacidad y confianza del usuario."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="folder_off"
                title="Mitigación de Brechas de Datos"
                description="Al identificar y abordar vulnerabilidades, la prueba de penetración de aplicaciones móviles ayuda a prevenir brechas de datos y las consecuencias legales, financieras y de reputación asociadas."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="person_check"
                title="Confianza y Retención del Usuario"
                description="Las aplicaciones móviles seguras fomentan la confianza del usuario, mejorando la retención de usuarios y la experiencia general del usuario."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="gavel"
                title="Cumplimiento y Normas"
                description="Muchas industrias y organismos reguladores exigen evaluaciones de seguridad rigurosas para las aplicaciones móviles para cumplir con los estándares de cumplimiento."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            El Rol de la Prueba de Penetración de Aplicaciones Móviles en la Ciberseguridad
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La Prueba de Penetración de Aplicaciones Móviles es una piedra angular de una estrategia integral de ciberseguridad en una era donde las aplicaciones móviles son centrales para las interacciones digitales. Asegura la seguridad de las aplicaciones móviles, protegiendo datos sensibles y la confianza del usuario en un mundo cada vez más impulsado por dispositivos móviles. Al adoptar la prueba de penetración de aplicaciones móviles, las organizaciones pueden mantener una postura de seguridad robusta, asegurando que sus aplicaciones móviles permanezcan resilientes ante amenazas y vulnerabilidades en evolución.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;